import { AxiosError } from 'axios'
import { useRouter } from 'next/router'
import { useQuery, UseQueryOptions } from 'react-query'

import { getToken, unauthorizedRedirect, useLocale } from '../../utils'
// import { getServiceURL } from '../menu-service-button'
import { SERVICES_URL } from '../menu-service-button'
import { userApi } from './user.api'
import { UNREAD_MESSAGES, USER_KEY } from './user.constants'
import { ProfileUser } from './user.types'

export const useQueryUser = <T = ProfileUser>(
  locale: string,
  options?: UseQueryOptions<ProfileUser, AxiosError, T>
) => {
  const token = getToken()
  const { asPath } = useRouter()
  const url = SERVICES_URL
  const redurectUrl = url.shop + asPath

  const data = useQuery([USER_KEY, locale], () => userApi.getUserInfo(locale), {
    ...options,
    onError: (error) => {
      options?.onError?.(error)

      unauthorizedRedirect(locale, error, redurectUrl)
    },
    enabled: !!token
  })

  return data
}
export const useUnreadMessageQuery = () => {
  const locale = useLocale()
  const data = useQuery({
    queryFn: () => userApi.getUnreadMessages(locale),
    queryKey: [UNREAD_MESSAGES, locale]
  })

  return data
}
